<script setup lang="ts">
import { miUsuario } from '@/services/usuarios';
import { ref } from 'vue';
import { defineProps, onMounted } from 'vue';

// Definimos las propiedades configurables
const props = defineProps({
  text: {
    type: String,
    default: '80% OFF EN TODOS LOS CURSOS DE HERNÁN CON TU CÓDIGO: #ORSAI2025',
  },
  buttonText: {
    type: String,
    default: 'Usar cupón',
  },
  link: {
    type: String,
    default: '#', // URL por defecto
  },
  backgroundColor: {
    type: String,
    default: 'bg-orange-500', // Clase Tailwind para el color de fondo
  },
  textColor: {
    type: String,
    default: 'text-white', // Clase Tailwind para el color del texto
  },
  buttonBackgroundColor: {
    type: String,
    default: 'bg-black', // Clase Tailwind para el color de fondo del botón
  },
  buttonTextColor: {
    type: String,
    default: 'text-white', // Clase Tailwind para el color del texto del botón
  },
});

function generarCheckoutURL(baseURL, usuario) {
  console.log("Usuario:", usuario);
  const queryParams = {
    "checkout[email]": usuario.email,
    "checkout[billing_address][first_name]": usuario.nombre,
    "checkout[billing_address][last_name]": usuario.apellido,
    "checkout[billing_address][address1]": usuario.direccion,
    "checkout[billing_address][address2]": usuario.dirPisoDepto || "",
    "checkout[billing_address][city]": usuario.ciudad,
    // Provincia o estado
    "checkout[billing_address][province]": usuario.provincia,
    "checkout[billing_address][zip]": usuario.codigoPostal,
    // Phone
    "checkout[phone]": usuario.telefono,
  };

  // Convertir el objeto a un query string
  const queryString = Object.keys(queryParams)
    .map(key => `${(key)}=${(queryParams[key])}`)
    .join('&');

  // Combinar la base URL con el query string
  const separador = baseURL.includes('?') ? '&' : '?';
  return `${baseURL}${separador}${queryString}`;
}

const linkConCheckout = ref('');
onMounted(async () => {
  // Lógica para inicializar el componente
  const usuario = await miUsuario();
  // Si es a tienda y checkout
  if (props.link.includes('tienda') && props.link.includes('checkout')) {
    linkConCheckout.value = generarCheckoutURL(props.link, usuario);
  } else {
    linkConCheckout.value = props.link;
  }

});

const copiado = ref(false);
// const copiarCodigo = () => {
//   copiado.value = true;
//   navigator.clipboard.writeText(props.buttonText);
//   console.log('Código copiado:', props.buttonText);

//   setTimeout(() => {
//     copiado.value = false;
//   }, 1500);
// };

const setearCopiado = () => {
  copiado.value = true;
  setTimeout(() => {
    copiado.value = false;
  }, 1500);
}

const copyTextFallback = (text) => {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed"; // Evitar que se desplace la página
  textarea.style.opacity = "0"; // Ocultar visualmente
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  try {
    document.execCommand("copy");
    console.log("Texto copiado al portapapeles (fallback)");
    setearCopiado();
  } catch (err) {
    console.error("Error al copiar el texto con fallback: ", err);
  }
  document.body.removeChild(textarea);
}

const copiarCodigo = () => {
  const text = props.buttonText;
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text)
      .then(() => {
        console.log("Texto copiado al portapapeles");
        setearCopiado();
      })
      .catch((err) => {
        console.error("Error al copiar el texto: ", err);
      });
  } else {
    copyTextFallback(text);
  }
}



</script>

<template>
  <div
    :class="[backgroundColor, 'flex justify-between items-center p-4 rounded-lg flex-col md:flex-row md:py-6 md:px-8']">
    <span :class="[textColor, 'font-medium text-sm md:text-base cursor-pointer']" v-html="text">
    </span>
    <div class="text-end flex justify-center items-center cursor-pointer">
      <div @click="copiarCodigo"
        class="py-2 px-4 bg-black rounded-md font-medium text-sm mt-2 md:my-0 text-white flex items-center gap-1">
        <!-- Ícono -->
        <svg v-if="!copiado" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor" class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor" class="size-5 text-green-500">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75" />
        </svg>

        <!-- Texto -->
        <span>{{ buttonText }}</span>
      </div>
      <!-- Boton para ir a la tienda -->
      <a :href="linkConCheckout" target="_blank"
        class="text-white cursor-pointer py-2 px-4 rounded-md font-medium text-sm mt-2 md:my-0 flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
        </svg>



      </a>
    </div>
  </div>
</template>

<style scoped>
/* Puedes agregar estilos adicionales aquí si es necesario */
</style>
